import enLocale from './en'
export default {
  ...enLocale,
  language: 'اللغة',
  confirm: 'تأكيد',
  go: 'اذهب',
  status: 'الحالة',
  balance: 'الرصيد',
  cash: 'نقد',
  createNew: 'إنشاء جديد',
  home: 'الرئيسية',
  market: 'السوق',
  markets: 'الأسواق',
  portfolio: 'المحفظة',
  license: 'ترخيص',
  withdraw: 'سحب',
  auditChecking: 'مراجعة جارية',
  insufficientFunds: 'رصيد غير كافٍ',
  buy: 'شراء',
  history: 'السجل',
  seeMore: 'عرض المزيد',
  theme: 'السمة',
  network: 'الشبكة',
  walletBalance: 'رصيد المحفظة',
  collect: 'تحصيل',
  approve: 'موافقة',
  ticket: 'ترخيص',
  category: 'الفئة',
  sortBy: 'ترتيب حسب',
  issue: 'إصدار',
  detail: 'تفاصيل',
  stakingType: 'ضمان',
  stakingTypeInfo: 'للمنع، قم برهن الرموز أو NFT الحالي.',
  subscriptionAmount: 'كمية الشراء',
  subscription: 'اشتراك',
  subscribe: 'شراء',
  max: 'الأقصى',
  marketClosed: 'السوق مغلق',
  deposit: 'إضافة',
  verifiedNFT: 'تحقق من الترخيص',
  select: 'اختيار',
  selected: 'محدد',
  moreNFT: 'المزيد من التراخيص',
  forecastEvent: 'الحدث',
  subscribeEndDate: 'آخر وقت تداول',
  specifyExpiryDate: 'تحديد وقت الانتهاء',
  endDate: 'وقت الانتهاء',
  validityPeriod: 'وقت الانقضاء',
  marketEndDate: 'وقت الانقضاء',
  liquidityMin: 'السيولة الدنيا',
  premiumMin: 'أدنى علاوة',
  paymentCurrency: 'عملة الدفع',
  defaultOdds: 'الرافعة الافتراضية',
  setDefaultOdds: 'اضبط الرافعة',
  minInvestAmout: 'حدد الحد الأدنى للاستثمار',
  depositMargin: 'أضف السيولة',
  totalPayment: 'إجمالي الدفع',
  rewards: 'مكافآت',
  rewardRate: 'معدل المكافأة',
  release: 'إطلاق',
  fee: 'رسوم',
  marginFeeRate: 'نسبة الرسوم',
  cdsInfoOne: 'للنشر، ارهن الهامش واضبط الرافعة والحد الأدنى.',
  cdsInfoTwo: 'الهامش غير المشارك قابل للسحب في أي وقت.',
  cdsInfoThree: 'أكثر من شخص واحد يبدأ الحوكمة.',
  deposited: 'تم الاستثمار',
  issued: 'تم الإصدار',
  depositedCDS: 'منتجات مستثمرة',
  totalProfit: 'إجمالي الربح',
  allOrDeposited: 'إجمالي/مستثمر',
  rewardsOrProfit: 'مكافآت/ربح',
  estimatedInvested: 'تقدير/مستثمر',
  profit: 'ربح',
  yesterdayProfit: 'ربح الأمس',
  eventConfirming: 'تأكيد الحدث',
  appeal: 'الطعن',
  appealing: 'جارٍ الطعن',
  appealFailed: 'فشل الطعن',
  occured: 'حدث',
  notOccured: 'لم يحدث',
  governanceMechanism: 'تفعيل الحوكمة عند >1 طعن',
  appealLimit: 'لا يزيد عن شخص واحد',
  waitResult: 'انتظار نتيجة الطعن',
  frozenMargin: 'هامش مجمد',
  marginBalance: 'رصيد الهامش',
  endTime: 'عد تنازلي للنهاية',
  guaranteeing: 'قيد التنفيذ',
  guaranteeingEvent: 'التنبؤ قيد التنفيذ',
  confirmsEventAdvance: 'تم التأكيد مبكرًا',
  waitConfirmation: 'في انتظار التأكيد',
  triggerEvent: 'تم تأكيد حدوث الحدث',
  notTriggerEvent: 'الحدث لم يحدث',
  defaultChallenging: 'حدث — تحدي',
  notDefaultChallenging: 'لم يحدث — تحدي',
  defaultChallengeFailed: 'حدث — فشل التحدي',
  notDefaultChallengeFailed: 'لم يحدث — فشل التحدي',
  defaultWaitingResult: 'حدث — انتظار الحوكمة',
  notDefaultWaitingResult: 'لم يحدث — انتظار الحوكمة',
  defaultGovernanceMechanism: 'حدث — وصادقت الحوكمة',
  notDefaultGovernanceMechanism: 'لم يحدث — وصادقت الحوكمة',
  cancel: 'إلغاء',
  defaultAhead: 'مبكرًا',
  occur: 'يحدث',
  notOccur: 'لا يحدث',
  stakingToChallenge: 'رهن للتحدي',
  challenged: 'تم التحدي',
  checking: 'جاري الفحص',
  fail: 'فشل',
  appealInfoOne: 'إذا كان الحكم خاطئًا، «تحدَّ» لتفعيل الحوكمة.',
  check: 'تحقق',
  contentIllegal: 'محتوى غير قانوني، عدّل قبل الإصدار',
  subscribed: 'منتجات مستثمرة',
  receivingCompensation: 'قيد الانتظار',
  received: 'إجمالي الدفع',
  receive: 'استلام',
  compensationAmount: 'مبلغ التعويض',
  liquidity: 'سيولة',
  injectLiquidity: 'حقن السيولة',
  uRLContent: 'عنوان/محتوى',
  resolutionSource: 'مصدر القرار',
  textareaInfo: 'صف الحدث بإيجاز.',
  share: 'مشاركة',
  USDT: 'USDT',
  donations: 'تبرعات',
  issueMsgPleaseSelectLicense: 'يرجى اختيار ترخيص',
  issueMsgLicenseCannotBeStaked: 'لا يمكن رهن الترخيص',
  issueMsgNetworkNotConnected: 'الشبكة غير متصلة',
  issueMsgEventEmpty: 'الحدث فارغ',
  issueMsgSelectLicense: 'اختر ترخيصًا',
  issueMsgLastTradingDateEmpty: 'آخر وقت تداول فارغ',
  issueMsgExpirationDateEmpty: 'وقت الانقضاء فارغ',
  issueMsgOptionsEmpty: 'الخيارات لا يمكن أن تكون فارغة',
  issueMsgOptionsLessThanTwo: 'على الأقل خياران',
  issueMsgOptionEmpty: 'محتوى الخيار فارغ',
  issueMsgOptionRepeated: 'محتوى الخيار مكرر',
  issueMsgLastTradingDateGreaterThanToday: 'يجب أن يكون آخر وقت تداول بعد اليوم',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'آخر وقت تداول أكبر من وقت الانقضاء',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'وقت نهاية الحدث {eventEndDate} أكبر من وقت نهاية الإيجار {rentalEndDate}',
  issueMsgInsufficientBalance: 'رصيد غير كافٍ',
  issueMsgTransactionFailed: 'فشل المعاملة',
  issueMsgIssueSuccess: 'تم الإصدار بنجاح',
  issueMsgTransactionCancelled: 'تم إلغاء المعاملة',
  short: {
    confirmsEventAdvance: 'حدث مبكرًا',
    waitConfirmation: 'بانتظار التأكيد',
    defaultChallenging: 'حدث — تحدي',
    notDefaultChallenging: 'لم يحدث — تحدي',
    defaultChallengeFailed: 'حدث — فشل التحدي',
    notDefaultChallengeFailed: 'لم يحدث — فشل التحدي',
    defaultWaitingResult: 'حدث — حوكمة',
    notDefaultWaitingResult: 'لم يحدث — حوكمة',
    defaultGovernanceMechanism: 'حدث — تأكيد الحوكمة',
    notDefaultGovernanceMechanism: 'لم يحدث — تأكيد الحوكمة'
  },
  wallet: {
    openWallet: 'افتح المحفظة',
    connectWallet: 'اتصل بالمحفظة',
    connectingWallet: 'جارٍ الاتصال',
    connectYourWallet: 'اتصل بمحفظتك',
    disconnect: 'قطع الاتصال',
    wrongNetwork: 'شبكة خاطئة'
  },
  NFT: {
    getPrediLicense: 'احصل على ترخيص Predi',
    referralRewards: 'مكافآت الإحالة',
    mintYourLicence: 'صك الترخيص',
    usageRights: 'حقوق الاستخدام',
    issuePredictionProducts: 'إصدار منتجات التنبؤ',
    governance: 'حوكمة',
    properties: 'خصائص',
    tradable: 'قابل للتداول',
    rentable: 'قابل للإيجار',
    usable: 'قابل للاستخدام',
    marketsToIssue: 'الأسواق للإصدار',
    times: 'مرات',
    availableTimes: 'المرات المتاحة',
    ticketId: 'معرّف التذكرة',
    cancelRentHint: 'الترخيص مؤجر، ألغِه أولًا للبيع.',
    sell: 'بيع',
    rent: 'تأجير',
    share: 'مشاركة',
    USDT: 'USDT',
    common: 'شائع',
    scarcity: 'ندرة',
    attributive: 'وصفي',
    numbers: 'عدد الإصدار',
    issueTip: 'إصدار 10 أسواق/تراخيص',
    price: 'السعر',
    success: 'نجاح',
    getNFT: 'تم الحصول على الترخيص',
    issueCDS: 'إصدار أسواق Predi',
    buyNow: 'اشترِ الآن',
    mintNow: 'اصك الآن',
    rule: 'قاعدة',
    comingSoon: 'قريبًا!',
    type: 'النوع',
    from: 'من',
    to: 'إلى',
    me: 'أنا',
    rented: 'مؤجر',
    sold: 'مباع',
    tabGetLicense: 'احصل على الترخيص',
    tabMyLicense: 'ترخيصي',
    bought: 'تم الشراء',
    boughtProducts: 'منتجات مشتراة',
    investedProducts: 'منتجات مستثمرة',
    issuedProducts: 'منتجات مُصدرة',
    positions: 'مراكز',
    options: 'خيارات',
    all: 'الكل',
    volume: 'حجم التداول',
    newest: 'الأحدث',
    price: 'السعر',
    pending: 'قيد الانتظار',
    audit: 'مراجعة',
    loading: 'جارٍ التحميل',
    home: 'الرئيسية',
    market: 'السوق',
    markets: 'الأسواق',
    portfolio: 'المحفظة',
    license: 'ترخيص',
    empowering: 'تمكين أصحاب الرؤية لتوقع المستقبل',
    myPositions: 'مواقعي',
    challengeCredit: 'رصيد التحدي',
    challengeStatus: 'حالة التحدي',
    succeed: 'نجاح',
    wait: 'انتظار',
    return: 'عائد',
    createYourOwnMarket: 'أنشئ سوقك الخاص',
    waitChallenge: 'الحدث ينتظر التحدي.',
    waitingGovernanceResult: 'انتظار نتيجة الحوكمة.',
    eventFinished: 'انتهى الحدث.',
    cancelled: 'أُلغي',
    predictionProduct: 'منتج التنبؤ',
    complaintCountdown: 'عد تنازلي للاعتراض',
    setResult: 'تعيين النتيجة',
    challenge: 'تحدي',
    recycleTicket: 'استرجاع التذكرة',
    eventCancelled: 'تم إلغاء الحدث.',
    auditChecking: 'مراجعة جارية',
    insufficientFunds: 'رصيد غير كافٍ',
    buyTicket: 'شراء تذكرة',
    buy: 'شراء',
    listYourToken: 'أدرج رمزك',
    setResultModalTitle: 'تعيين النتيجة:',
    cancelModalTitle: 'إلغاء',
    cancelIrreversible: 'الإلغاء لا رجعة فيه.',
    challengeModalTitle: 'تحدي',
    challengeStakeIntro: 'عند انحراف الحقائق تُعاد لك.',
    challengeStakeButton: 'PRDS للتحدي',
    history: 'السجل',
    seeMore: 'عرض المزيد',
    licenses: 'تراخيص',
    prediLicense: 'ترخيص Predi',
    issuableQuantity: 'كمية قابلة للإصدار',
    disabled: 'معطل',
    battleImage: 'صورة',
    upload: 'رفع',
    showSample: 'عرض مثال',
    battleInformation: 'معلومات',
    baseToken: 'الرمز الأساسي',
    collateral: 'ضمان',
    currentLicense: 'الترخيص الحالي',
    predictionProject: 'مشروع التنبؤ:',
    issueExpireIntro: 'عند الانتهاء يتشارك الصحيحون الرموز.',
    issueParticipateUntil: 'المشاركة حتى',
    issueConfirmAdvance: 'إذا حدث مبكرًا يمكن التأكيد مسبقًا.',
    issueChallengeWithin7Days: 'الاعتراض خلال 7 أيام.',
    issueAttention: 'Predi للترفيه/الاجتماع. القمار ممنوع.',
    eventSampleTitle: 'حدث',
    issueSampleCrypto: '[عملات] نطاق سعر BTC نهاية 2025؟',
    issueSampleFinance: '[مالية] قرار الفائدة للـFed في Q3 2025؟',
    issueSampleTechnology: '[تقنية] من سيطلق أول مساعد روبوتي ذاتي بالذكاء الاصطناعي؟',
    issueSampleSports: '[رياضة] من سيفوز بكأس العالم 2026؟',
    issueSampleSociety: '[مجتمع] أي منصة لديها أكبر MAU في 2025؟',
    issueSampleOthers: '[أخرى] متى تنتهي حرب روسيا-أوكرانيا؟',
    issuerResult: 'نتيجة المُصدِر',
    daoResult: 'نتيجة DAO',
    predictionToken: 'رمز التنبؤ',
    issuer: 'المُصدِر',
    issuerProfit: 'ربح المُصدِر'
  },
  claim: {
    title: 'احصل على PRDs مجانًا',
    subtitle: 'احصل على رموزك بنقرة واحدة',
    walletAddress: 'عنوان المحفظة',
    status: 'الحالة',
    connectWalletFirst: 'يرجى الاتصال أولًا',
    eligibility: {
      claimed: 'تم الاستلام',
      eligible: 'مؤهل للاستلام',
      error: 'خطأ في التحقق'
    },
    button: {
      claim: 'استلام',
      alreadyClaimed: 'تم الاستلام',
      connect: 'اتصال'
    },
    footerNotice: 'محفظة مرة واحدة فقط. تأكد من الشبكة الصحيحة.',
    messages: {
      connectFirst: 'يرجى الاتصال بمحفظتك أولًا',
      claimSuccess: 'تم الاستلام بنجاح!',
      claimFailed: 'فشل، حاول لاحقًا',
      txCancelled: 'تم إلغاء المعاملة',
      onlyOnce: 'كل مستخدم مرة واحدة فقط',
      insufficientBalance: 'رصيد العقد غير كافٍ، حاول لاحقًا'
    }
  },
  
  // Additional top-level keys from en.js
  inputSearchText: 'يرجى إدخال محتوى البحث',
  predictionProduct: 'منتج التنبؤ',
  listYourToken: 'أدرج رمزك',
  description: 'وصف',
  positions: 'المواقف',
  options: 'الخيارات',
  all: 'الكل',
  volume: 'الحجم',
  newest: 'الأحدث',
  pending: 'قيد الانتظار',
  audit: 'مراجعة',
  loading: 'جارٍ التحميل',
  challengeCredit: 'رصيد التحدي',
  challengeStatus: 'حالة التحدي',
  succeed: 'نجاح',
  wait: 'انتظار',
  return: 'عائد',
  waitChallenge: 'الحدث ينتظر التحدي.',
  complaintCountdown: 'عد تنازلي للاعتراض',
  setResult: 'تعيين النتيجة',
  issueParticipateUntil: 'المشاركة حتى',
  specifyLastTradingDate: 'تحديد آخر وقت تداول',
  empowering: 'تمكين أصحاب الرؤية لتوقع المستقبل',
  amount: 'المبلغ',
  createYourOwnMarket: 'إنشاء السوق الخاص بك'
}